// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qYnNM","label":"styles_label__2YsLF"};